import { PortalRouteParams, State, ExtraUserInfo } from "../portal_client";
import { Option, none } from "widgets-for-react";
import { AppState } from "../../components/portal/state";

export let router_events_handler = (r: PortalRouteParams, s: AppState<State, PortalRouteParams, ExtraUserInfo>) : Option<AppState<State, PortalRouteParams, ExtraUserInfo>> =>
        none()